import React from "react"
import ReactTableHeader from "components/Common/ReactTableHeader"
import Pagination from "./Pagination"
import { useSearchQuery_DEPRECATED } from "store/search-filter/search-filter.reducer"
import BenchmarkFilter from "./BenchmarkFilter"

const BenchmarkHeader = () => {
  const [query, setQuery] = useSearchQuery_DEPRECATED("benchmarks")
  return (
    <ReactTableHeader
      value={query}
      onQueryChange={query => setQuery(query)}
      filter={<BenchmarkFilter />}
      icon="comparison"
      title="Benchmark Logs"
    >
      <Pagination />
    </ReactTableHeader>
  )
}

export default BenchmarkHeader
